import React from "react"
import {
  amspaudaLogo,
  bioanalizesLogo,
  biomatterLogo,
  dspLogo,
  emailLogo,
  fbLogo,
  gitlabLogo,
  gmcLogo,
  igemLogo,
  igLogo,
  laboramaLogo,
  lineliberaLogo,
  medicinaPracticaLogo,
  progemLogo,
  thermoLogo,
  vortoGamaLogo,
  vuLogo,
  websiteLogo,
} from "../../../../static/svgs/footer"

const DesktopFooter = () => (
  <div className="w-full flex flex-row h-full px-4 md:gap-8 lg:gap-10 xl:gap-16 2xl:gap-24 justify-center">
    <div className="flex flex-col justify-center">
      <img alt="" src={igemLogo} />
    </div>
    <div className="flex flex-col justify-center md:gap-3 lg:gap-4 xl:gap-8 2xl:gap-10 scale-75">
      <div className="uppercase font-raleway-medium font-medium text-base lg:text-xl">
        FOLLOW US
      </div>
      <div className="flex flex-row justify-start md:gap-3 lg:gap-4 xl:gap-8 2xl:gap-10">
        <a href="https://www.instagram.com/igem_vilnius" target="_blank">
          <img alt="" src={igLogo} />
        </a>
        <a href="https://www.facebook.com/VilniusiGEM" target="_blank">
          <img alt="" src={fbLogo} />
        </a>
      </div>
      <div className="uppercase font-raleway-medium font-medium text-base lg:text-xl">
        CONTACT US
      </div>
      <div className="flex flex-row justify-start md:gap-3 lg:gap-4 xl:gap-8 2xl:gap-10">
        <a href="https://vilniusigem.lt/" target="_blank">
          <img alt="" src={websiteLogo} />
        </a>
        <a href="mailto:info@vilniusigem.lt">
          <img
            alt=""
            className="xl:w-12 2xl:w-16 xl:h-8 2xl:h-11 mt-2"
            src={emailLogo}
          />
        </a>
      </div>
      <div className="uppercase font-raleway-medium font-medium text-base lg:text-xl">
        WIKI REPOSITORY
      </div>
      <div className="flex flex-row justify-start">
        <a
          href="https://gitlab.igem.org/2022/vilnius-lithuania"
          target="_blank"
        >
          <img alt="" src={gitlabLogo} />
        </a>
      </div>
    </div>
    <div className="h-full flex flex-col justify-center">
      <div className="inline-block border border-solid border-white h-4/6 md:ml-5 lg:ml-20" />
    </div>
    <div className="flex flex-col justify-center gap-6 scale-75 lg:scale-50">
      <div className="flex flex-row md:gap-8 lg:gap-10 xl:gap-12 2xl:gap-14 items-center">
        <a href="https://www.vu.lt/" target="_blank">
          <img alt="" src={vuLogo} />
        </a>
        <a href="https://www.thermofisher.com/" target="_blank">
          <img alt="" src={thermoLogo} />
        </a>
      </div>
      <div className="flex flex-row md:gap-8 lg:gap-10 xl:gap-14 2xl:gap-16  items-center">
        <a href="https://medicinapractica.lt/" target="_blank">
          <img alt="" src={medicinaPracticaLogo} />
        </a>
        <a href="https://www.gmc.vu.lt/" target="_blank">
          <img alt="" src={gmcLogo} />
        </a>
        <a href="https://www.biomatterdesigns.com/" target="_blank">
          <img alt="" src={biomatterLogo} />
        </a>
      </div>
      <div className="flex flex-row md:gap-8 lg:gap-10 xl:gap-6 2xl:gap-8  items-center">
        <a href="https://bioanalysis.lt/" target="_blank">
          <img alt="" src={bioanalizesLogo} />
        </a>
        <a href="https://linealibera.lt/" target="_blank">
          <img alt="" src={lineliberaLogo} />
        </a>
        <a href="https://linealibera.lt/" target="_blank">
          <img alt="" src={progemLogo} />
        </a>
        <a href="https://www.vortogama.lt/en/" target="_blank">
          <img alt="" src={vortoGamaLogo} />
        </a>
      </div>
      <div className="flex flex-row md:gap-8 lg:gap-10 xl:gap-16 2xl:gap-20 items-center">
        <a href="https://www.laborama.lt/" target="_blank">
          <img alt="" src={laboramaLogo} />
        </a>
        <a href="https://darbosaugospriemones.lt/" target="_blank">
          <img alt="" src={dspLogo} />
        </a>
        <a href="https://amspauda.lt/" target="_blank">
          <img alt="" src={amspaudaLogo} />
        </a>
      </div>
    </div>
  </div>
)

export default DesktopFooter
